<template>
  <v-layout align-center class="conversation-marker">
    <hr>
    <span class="date px-4" v-if="hasDate">
      {{date}}
    </span>
  </v-layout>
</template>

<script>
export default {
  name: 'ConversationMarker',
  props: {
    marker: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasDate() {
      return this.marker.type === 'marker:date_transition';
    },
    date() {
      const m = new Date(this.marker.ts).toLocaleString([], { month: 'short' });
      const d = new Date(this.marker.ts).toLocaleString([], { day: 'numeric' });
      const y = new Date(this.marker.ts).toLocaleString([], { year: 'numeric' });
      return `${d} ${m} ${y}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../common/styles/_colors.scss';

.conversation-marker {
  font-family: 'Raleway', sans-serif;
  color: $ypo-dark-gray;

  hr {
    width: 100%;
    border: none;
    border-top: 2px solid $ypo-medium-gray;
    margin-left: 56px;
  }

  .date {
    white-space: nowrap;
  }
}
</style>

